import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

import employee from './employee'
import configuration from './configuration'
import static_content from './static_content'
import authentication from './authentication'
import maintenance from './maintenance'
import { flashMessage } from 'redux-flash-messages'

export default (history) => combineReducers({
  router: connectRouter(history),
  employee,
  configuration,
  static_content,
  auth: authentication,
  maintenance,
  flashMessage
})
